export const enum ButtonSizeEnum {
  small = 'small',
  default = 'default',
  large = 'large',
}
